<template>
  <div>
    <div v-if="tournament">
      <div v-if="tournament.regulations">
        <div class="md-subhead">Regulations</div>
        <pre>{{tournament.regulations}}</pre>
      </div>
      <div v-if="tournament.commments">
        <div class="md-subhead">Comments</div>
        <pre>{{tournament.comments}}</pre>
      </div>
    </div>
    <div v-else>
      <p>Oops... no current tournament</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TournamentDetails",
  props: { tournament: Object }
};
</script>


// WEBPACK FOOTER //
// tournamentDetails.vue?54128be6